export default "__VITE_ASSET__CjZCVDXl__"